import React, { useRef, useEffect, useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import CardRelatorio from '../components/CardRelatorio';
//Helpers
import { getSessionCookie } from '../../../helpers/cookies';
import mascaras from '../../../helpers/mascaras';

//Context
import { useAuth } from '../../../context/auth';

export default function RelatorioEntradasAvulsas({ dadosRelatorio, btnVoltar, filtros }) {
    const { setupVariavel } = useAuth();

    //Referencia do relatorio para download do csv
    const exportRef = useRef(null);
    //Botão de exportação csv
    const BtnExportCsv = () => {
        return (
            <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
                <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
            </Button>
        )
    }
    //Referencia para a geração de pdf
    const refRelatorio = useRef();
    //Dados do usuario que esta logado no sistema
    const usuario = getSessionCookie();
    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersEntradas = [
        { value: "Nº COLETA", objectValue: "identificacaoColeta", col: "3" },
        { value: "MODALIDADE", objectValue: "modadalidade", col: "6" },
        { value: "PLACA", objectValue: "placa", col: "3" },

        { value: "FANTASIA", objectValue: "fantasia", col: "4" },
        { value: "SITUAÇÃO", objectValue: "situacao", col: "4" },

        { value: "DATA REGISTRO VEÍCULO", objectValue: "dataRegistroVeiculo", col: "6" },
        { value: "RESPONSÁVEL VEÍCULO", objectValue: "responsavel", col: "6" },

        { value: "ENDEREÇO VEÍCULO", objectValue: "endereco", col: "12" },

        { value: "DATA ENTRADA", objectValue: "dataEntrada", col: "12" },
        { value: "PESO ENTRADA(Kg", objectValue: "pesoEntrada", col: "6" },
        { value: "USUÁRIO ENTRADA", objectValue: "usuarioEntrada", col: "6" },

        { value: "DATA SAÍDA", objectValue: "dataSaida", col: "12" },
        { value: "PESO SAÍDA(Kg", objectValue: "pesoSaida", col: "6" },
        { value: "USUÁRIO SAÍDA", objectValue: "usuarioSaida", col: "6" },
    ];
    //Headers para exportar csv
    const headersExport = headersEntradas.map(value => {
        return { label: value.value, key: value.objectValue }
    })
    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório de entradas avulsas",
    });

    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
            <CSVLink separator={";"} data={dadosRelatorio.listaEntradasAvulsas} headers={headersExport} filename="Relatorio de entradas avulsas.csv" target="_blank" ref={exportRef}></CSVLink>

            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {usuario.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}}  />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório de entradas avulsas</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='rounded-3 bg-secondary text-light p-2'>Dados do destino final</h5>
                    <Row className='content-rel'>
                        <div className="col-6"><span className="fw-bold">Nome:</span> {dadosRelatorio.destino.fantasia}</div>
                        <div className="col-6"><span className="fw-bold">CNPJ:</span> {mascaras.cnpjMask(dadosRelatorio.destino.cnpj)}</div>
                        <div className="col-4"><span className="fw-bold">Responsável:</span> {dadosRelatorio.destino.responsavel}</div>
                        <div className="col-4"><span className="fw-bold">E-mail:</span> {dadosRelatorio.destino.email}</div>
                        <div className="col-4"><span className="fw-bold">Telefone:</span> {mascaras.celularMask(dadosRelatorio.destino.fone)}</div>
                        <div className="col-4"><span className="fw-bold">CEP:</span> {mascaras.cepMask(dadosRelatorio.destino.cep)}</div>
                        <div className="col-4"><span className="fw-bold">Cidade:</span> {dadosRelatorio.destino.cidade}</div>
                        <div className="col-4"><span className="fw-bold">UF:</span> {dadosRelatorio.destino.uf}</div>
                        <div className="col-4"><span className="fw-bold">Bairro:</span> {dadosRelatorio.destino.bairro}</div>
                        <div className="col-4"><span className="fw-bold">Rua:</span> {dadosRelatorio.destino.logradouro}</div>
                        <div className="col-4"><span className="fw-bold">Numero:</span> {dadosRelatorio.destino.numero}</div>
                    </Row>
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>ENTRADAS AVULSAS</h5>
                    <CardRelatorio headers={headersEntradas} items={dadosRelatorio.listaEntradasAvulsas} />
                </div>
            </div>
        </MainCard>
    )
}